import { render, staticRenderFns } from "./SettingsCategory.vue?vue&type=template&id=2ce88cbc"
import script from "./SettingsCategory.vue?vue&type=script&lang=js"
export * from "./SettingsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports